import React, { useState } from "react";
import { Input, Spin } from "antd";
import { SubmitAnswerApi } from "../../../api/request/service.js";
import toast from "react-hot-toast";

const MyInput = ({ data }) => {
  const question = data?.service_question;
  const isReviewedChecked = data?.is_sealed;
  const disabledStyle = { cursor: "not-allowed", opacity: 0.6 };
  const [isLoading, setIsLoading] = useState(false)

  const onBlur = async (event) => {
    if (!event?.target?.value) return;
    try {
      setIsLoading(false)
      const answer = { id: data?.id, response_text: event?.target?.value };
      await SubmitAnswerApi(answer);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <div>
      {data?.is_show === 1 && (
        <div className="mt-6 relative">
          {isLoading && <Spin className="absolute top-[50% ] left-[50%] z-10 transform translate-x-[-50%]  translate-y-[50%] w-full justify-center items-center h-full" />}
          <div className="flex items-start gap-2 mb-2">
            {question?.is_required === 1 && (
              <p className="text-red-600 text-lg">*</p>
            )}
            <p>{question?.field_label}</p>
          </div>

          <Input
            className="py-3 ps-4 w-full"
            disabled={isReviewedChecked || isLoading}
            style={isReviewedChecked ? disabledStyle : {}}
            size="large"
            type="text"
            // placeholder="Free Entry"
            defaultValue={data?.response_text}
            onBlur={onBlur}
          />
        </div>
      )}
    </div>
  );
};

export default MyInput;
